import { all, put, call, takeEvery } from "redux-saga/effects";
import { SURVEY_LIST, SURVEY_LIST_SUCCESS, SAVE_SURVEY, SAVE_SURVEY_SUCCESS, EDIT_SURVEY, EDIT_SURVEY_SUCCESS, PUBLISH_SURVEY, DELETE_SURVEY_SUCCESS, DELETE_SURVEY, SHOW__HIDE_LOADER, UPDATE_SURVEY_DATE, UPDATE_SURVEY_DATE_SUCCESS, UNMOUNT_ADDEDIT_SURVEY_SUCCESS, UNMOUNT_ADDEDIT_SURVEY, GLOBAL_SURVEY_LIST_SUCCESS, GET_STATUS_QUESTION_SUCCESS, GET_QUESTION_STATUS, SAVE_SURVEY_FAIL, RESET_QUESTION_STATUS } from '../constants/constants';
import { getSurveyListCall, saveSurveyCall, editSurveyCall, publishSurveyCall, deleteSurveyCall, updateSurveyDateCall, getSurveyQuestionStatus } from '../effects/api/api.survey';

function* getSurveyList() {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getSurveyListCall);
        yield put({ payload: response, type: GLOBAL_SURVEY_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* saveSurvey(data: any) {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });
        const response = yield call(saveSurveyCall, data);

        if (response && response.data && response.data.success) {
            yield put({ payload: undefined, type: SAVE_SURVEY_SUCCESS });
        } else {
            if (data.payload.BaseSurvey.status === 2) {
                data.payload.BaseSurvey.status = null;

                const surveyFailedData = {
                    baseSurvey: data.payload.BaseSurvey,
                    countryModuleSurveyMapping: data.payload.CountryModuleSurveyMapping,
                    isSurveyExist: true
                }

                yield put({ payload: surveyFailedData, type: SAVE_SURVEY_FAIL });
            }
        }

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* editSurvey(data: any) {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(editSurveyCall, data);
        yield put({ payload: response, type: EDIT_SURVEY_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* getQuestionStatusSurvey(data: any) {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(getSurveyQuestionStatus, data);
        yield put({ payload: response.data.payload, type: GET_STATUS_QUESTION_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* resetQuestionStatusSurvey(data: any) {
    try {
        yield put({ payload: data.payload, type: GET_STATUS_QUESTION_SUCCESS });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* updateSurveyDate(data: any) {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(updateSurveyDateCall, data);
        yield put({ payload: response, type: SAVE_SURVEY_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* publishSurvey(data: any) {
    try {
        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(publishSurveyCall, data);
        yield put({ payload: response, type: UPDATE_SURVEY_DATE_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}
function* deleteSurvey(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        const response = yield call(deleteSurveyCall, data);
        yield put({ payload: response, type: DELETE_SURVEY_SUCCESS });

        const updateGrid = yield call(getSurveyListCall);
        yield put({ payload: updateGrid, type: SURVEY_LIST_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

function* unmountAddEditSurvey(data: any) {
    try {

        yield put({ type: SHOW__HIDE_LOADER, payload: true });

        yield put({ payload: data, type: UNMOUNT_ADDEDIT_SURVEY_SUCCESS });

        yield put({ type: SHOW__HIDE_LOADER, payload: false });

    } catch (err) {
        yield put({ type: SHOW__HIDE_LOADER, payload: false });
    }
}

export const surveyData = (state: any) => state.survey
export default function* SurveySaga() {
    yield all([
        takeEvery(SURVEY_LIST, getSurveyList),
        takeEvery(GET_QUESTION_STATUS, getQuestionStatusSurvey),
        takeEvery(SAVE_SURVEY, saveSurvey),
        takeEvery(EDIT_SURVEY, editSurvey),
        takeEvery(PUBLISH_SURVEY, publishSurvey),
        takeEvery(DELETE_SURVEY, deleteSurvey),
        takeEvery(UPDATE_SURVEY_DATE, updateSurveyDate),
        takeEvery(UNMOUNT_ADDEDIT_SURVEY, unmountAddEditSurvey),
        takeEvery(RESET_QUESTION_STATUS, resetQuestionStatusSurvey),
    ])
}


// WEBPACK FOOTER //
// ./src/saga/saga.survey.tsx